(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luxurial-bottom-navigation"]) return;
  try {
    
  if(!customElements.get('luxurial-bottom-navigation')){
    customElements.define('luxurial-bottom-navigation',class extends HTMLElement{
      connectedCallback(){
        if(this.initialized)return;
        this.initialized=true;
        const trigger=this.querySelector('[data-lux-filter-open]');
        const dialog=this.querySelector('dialog');
        if(!trigger||!dialog)return;
        trigger.addEventListener('click',()=>{dialog.showModal();trigger.setAttribute('aria-expanded','true');document.body.classList.add('lux-nav-filter-open')});
        this.querySelector('[data-lux-filter-close]').addEventListener('click',()=>dialog.close());
        dialog.addEventListener('close',()=>{trigger.setAttribute('aria-expanded','false');document.body.classList.remove('lux-nav-filter-open')});
        dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()});
        this.querySelector('.lux-nav-filter__form').addEventListener('submit',event=>{
          event.preventDefault();
          const form=event.currentTarget;
          const target=new URL(form.action,location.origin);
          for(const [name,value]of new FormData(form)){if(String(value).trim())target.searchParams.append(name,value)}
          const preview=new URLSearchParams(location.search).get('preview_theme_id');
          if(preview)target.searchParams.set('preview_theme_id',preview);
          location.assign(target.href);
        });
      }
      disconnectedCallback(){document.body.classList.remove('lux-nav-filter-open')}
    });
  }

  } catch(e) { console.error(e); }
})();
})();
